// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-group {
    display: flex;
    flex-direction: column;
  }

  .dialog-title {
    text-align: center;
    display: block;
  }

  .dialog-actions{
    align-items: center;
    display: block;
    text-align: right;
    align-content: space-around;
  }


  `, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/include-audit-trail/include-audit-trail.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,2BAA2B;EAC7B","sourcesContent":[".radio-group {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .dialog-title {\n    text-align: center;\n    display: block;\n  }\n\n  .dialog-actions{\n    align-items: center;\n    display: block;\n    text-align: right;\n    align-content: space-around;\n  }\n\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
